// services/childcare/dashboard.js
import { api } from "./utils";

// Helper to handle API responses
const handleResponse = async (promise) => {
  try {
    const response = await promise;
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

// Get dashboard stats
export const getDashboardStats = async () => {
  return handleResponse(api.get("/childcare/dashboard/stats"));
};

// Get children overview
export const getChildrenOverview = async () => {
  return handleResponse(api.get("/childcare/dashboard/children-overview"));
};

// Get attendance summary
export const getAttendanceSummary = async (date = null) => {
  const params = date ? { date } : {};
  return handleResponse(
    api.get("/childcare/dashboard/attendance-summary", { params }),
  );
};

// Get financial summary
export const getFinancialSummary = async (period = "month") => {
  return handleResponse(
    api.get("/childcare/dashboard/financial-summary", { params: { period } }),
  );
};

// Get upcoming events
export const getUpcomingEvents = async (limit = 5) => {
  return handleResponse(
    api.get("/childcare/dashboard/upcoming-events", { params: { limit } }),
  );
};

// Get staff summary
export const getStaffSummary = async () => {
  return handleResponse(api.get("/childcare/dashboard/staff-summary"));
};

// Get recent activities
export const getRecentActivities = async () => {
  return handleResponse(api.get("/childcare/dashboard/recent-activities"));
};
